import React from 'react';
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element }) => {
  const token = Cookies.get('sc_Token');
  return token ? element : <Navigate to="/" />;
};

export default ProtectedRoute; 
